export default __webpack_public_path__ + "static/media/animation11.504bf950.mp4";